<template>
  <div>
    <v-row class="ma-0">
      <v-btn small>問{{ !$route.params.id ? Number(no) + 1 : Number(no) }}</v-btn>
    </v-row>
    <v-row class="mx-0 mt-2 lead-sentence">
      <span class>{{ formGeneral.leadSentence }}</span>
    </v-row>
    <v-row class="mx-0 mt-5" justify="center">
      <span class="pre-wrap text--h4 font-weight-bold">
        {{ formGeneral.name1 }}
        <u>{{ formGeneral.kanji }}</u>
        {{ formGeneral.name2 }}
      </span>
    </v-row>
    <v-row class="mx-0 mt-5">
      <v-col
        :cols="!checkLength ? 6 : 12"
        v-for="(answers, index) in formGeneral.answers"
        :key="index"
      >
        <button class="width-10 pa-1 grey lighten-4 button-template">
          {{ answers.value ? answers.value : defaultValue[index] }}
        </button>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: ["no"],
  store: ["formGeneral"],
  data() {
    return {
      defaultValue: ["回答1", "回答2", "回答3", "回答4"],
      // eslint-disable-next-line no-useless-escape
      textPlaceholderDirective:
        "＿＿＿の　ことばは　ひらがなで　どう　かきますか。\n いちばん　いいものを　ひとつ　えらんでください。",
    };
  },
  computed: {
    checkLength() {
      return Boolean(this.formGeneral.answers.find((e) => e.value.length > 9));
    },
  },
};
</script>
<style scoped>
.lead-sentence {
  white-space: pre-wrap;
  padding-bottom: 8px;
  border-bottom: 5px dotted #feb798;
}
u {
  text-decoration: none;
  border-bottom: 2px solid black;
}
button {
  word-wrap: break-word;
}
</style>